import { useStrictLocalization } from "@faire/web/common/localization";
export var useLoggedOutRetailerNodes = function useLoggedOutRetailerNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var loggedOutRetailerNodes = {
    L1: {
      Account: strictLocalize({
        id: "8viWk0",
        defaultMessage: [{
          "type": 0,
          "value": "Accountinstellingen (bijv. adres bijwerken)"
        }]
      }),
      HowFaireWork: strictLocalize({
        id: "6TLwqu",
        defaultMessage: [{
          "type": 0,
          "value": "Hoe werkt Faire"
        }]
      }),
      Invoices: strictLocalize({
        id: "t1H2TU",
        defaultMessage: [{
          "type": 0,
          "value": "Facturen en betalingen"
        }]
      }),
      Items: strictLocalize({
        id: "1qDrDS",
        defaultMessage: [{
          "type": 0,
          "value": "Ontbrekende en beschadigde artikelen"
        }]
      }),
      Orders: strictLocalize({
        id: "9QHKE5",
        defaultMessage: [{
          "type": 0,
          "value": "Bestelstatus"
        }]
      }),
      Returns: strictLocalize({
        id: "Gi6QMt",
        defaultMessage: [{
          "type": 0,
          "value": "Retourzendingen en terugbetalingen"
        }]
      }),
      GeneralShipping: strictLocalize({
        id: "ueCCEa",
        defaultMessage: [{
          "type": 0,
          "value": "Algemene verzendingsvragen"
        }]
      }),
      Other: strictLocalize({
        id: "8PmlMt",
        defaultMessage: [{
          "type": 0,
          "value": "Andere problemen met retailers"
        }]
      })
    },
    L2: {
      ImportFeesAndDuties: strictLocalize({
        id: "Fjt2kE",
        defaultMessage: [{
          "type": 0,
          "value": "Invoerheffingen en rechten"
        }]
      }),
      BuyingInternational: strictLocalize({
        id: "16zI+k",
        defaultMessage: [{
          "type": 0,
          "value": "Internationaal inkopen"
        }]
      }),
      Other: strictLocalize({
        id: "mTbErA",
        defaultMessage: [{
          "type": 0,
          "value": "Anders"
        }]
      })
    }
  };
  return loggedOutRetailerNodes;
};